"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppRoutes = void 0;
const react_1 = __importDefault(require("react"));
const react_router_dom_1 = require("react-router-dom");
const DashboardAdmin_1 = __importDefault(require("../../components/Admin/DashboardAdmin/DashboardAdmin"));
const AdminLayout_1 = __importDefault(require("../../components/Admin/AdminLayout/AdminLayout"));
const PagesError404_1 = __importDefault(require("../../components/Shared/PagesError/PagesError404"));
const Login_1 = __importDefault(require("../../components/AppAuth/AppAuth/Login"));
const AuthVerifie_1 = __importDefault(require("../../components/AppAuth/AppAuth/AuthVerifie"));
const ResetPassword_1 = __importDefault(require("../../components/AppAuth/AppAuth/ResetPassword"));
const ForgotPassword_1 = __importDefault(require("../../components/AppAuth/AppAuth/ForgotPassword"));
const NotificationAdmin_1 = __importDefault(require("../../components/Admin/NotificationAdmin/NotificationAdmin"));
const NotificationsPubliees_1 = __importDefault(require("../../components/Admin/NotificationAdmin/NotificationsPubliees/NotificationsPubliees"));
const NotificationsProgrammees_1 = __importDefault(require("../../components/Admin/NotificationAdmin/NotificationsProgrammees/NotificationsProgrammees"));
const TransactionAdmin_1 = __importDefault(require("../../components/Admin/TransactionAdmin/TransactionAdmin"));
const UtilisateursAdmin_1 = __importDefault(require("../../components/Admin/UtilisateurAdmin/UtilisateursAdmin"));
const SuggestionAdmin_1 = __importDefault(require("../../components/Admin/SuggestionAdmin/SuggestionAdmin"));
const SosRemorquagesAdmin_1 = __importDefault(require("../../components/Admin/SosRemorquagesAdmin/SosRemorquagesAdmin"));
const ParametresAdmin_1 = __importDefault(require("../../components/Admin/ParametresAdmin/ParametresAdmin"));
const ParametresTarifs_1 = __importDefault(require("../../components/Admin/ParametresAdmin/Parametrestarifs/ParametresTarifs"));
const ParametresEspaces_1 = __importDefault(require("../../components/Admin/ParametresAdmin/ParametresEspace/ParametresEspaces"));
const ParametresPolitiques_1 = __importDefault(require("../../components/Admin/ParametresAdmin/ParametresPolitiques/ParametresPolitiques"));
const ParametresAdmins_1 = __importDefault(require("../../components/Admin/ParametresAdmin/ParametresAdmins/ParametresAdmins"));
const MonCompteAdmin_1 = __importDefault(require("../../components/Admin/MonCompteAdmin/MonCompteAdmin"));
const DetailsUtilisateurAdmin_1 = __importDefault(require("../../components/Admin/UtilisateurAdmin/DetailsUtilisateurAdmin"));
const routerUtils_1 = require("./routerUtils");
const user_type_1 = require("../../utils/api/user/user.type");
const ParametresDirection_1 = __importDefault(require("../../components/Admin/ParametresAdmin/ParametresDirections/ParametresDirection"));
const ParametresOptions_1 = __importDefault(require("../../components/Admin/ParametresAdmin/Options/ParametresOptions"));
const ParametresFaqs_1 = __importDefault(require("../../components/Admin/ParametresAdmin/ParametresFaqs/ParametresFaqs"));
const SosRemorquagesDetails_1 = __importDefault(require("../../components/Admin/SosRemorquagesAdmin/SosRemorquagesDetails"));
const DashboardSocketIo_1 = __importDefault(require("../../components/Admin/DashboardSocketIo/DashboardSocketIo"));
const ORMMetrics_1 = __importDefault(require("../../components/Admin/ORMMetrics/ORMMetrics"));
const RapidosAdmin_1 = __importDefault(require("../../components/Admin/RapidosAdmin/RapidosAdmin"));
const SignalementAdmin_1 = __importDefault(require("../../components/Admin/SignalementAdmin/SignalementAdmin"));
const CGU_1 = __importDefault(require("../../components/CGU/CGU"));
const MyNotifications_1 = __importDefault(require("../../components/Admin/MyNotifications/MyNotifications"));
const MyNotificationsContent_1 = __importDefault(require("../../components/Admin/MyNotifications/MyNotificationsContent/MyNotificationsContent"));
const AdminCheckWaze_1 = require("../../components/Admin/AdminCheckWaze/AdminCheckWaze");
const AdminCheckGoogleMaps_1 = require("../../components/Admin/AdminCheckGoogleMaps/AdminCheckGoogleMaps");
const StatistiquesReportingAdmin_1 = __importDefault(require("../../components/Admin/StatistiquesReportingAdmin/StatistiquesReportingAdmin"));
exports.AppRoutes = [
    {
        path: "/",
        element: (react_1.default.createElement(routerUtils_1.RedirectAuthRoute, null,
            react_1.default.createElement(Login_1.default, null))),
    },
    {
        path: "/double-authentification/:userId",
        element: (react_1.default.createElement(routerUtils_1.RedirectAuthRoute, null,
            react_1.default.createElement(AuthVerifie_1.default, null))),
    },
    {
        path: "/mot-de-passe-oublie",
        element: (react_1.default.createElement(routerUtils_1.RedirectAuthRoute, null,
            react_1.default.createElement(ForgotPassword_1.default, null))),
    },
    {
        path: "/reinitialiser-mot-de-passe",
        element: (react_1.default.createElement(routerUtils_1.RedirectAuthRoute, null,
            react_1.default.createElement(ResetPassword_1.default, null))),
    },
    {
        path: 'conditions-generales-d-utilisation',
        element: react_1.default.createElement(CGU_1.default, null)
    },
    {
        path: "*",
        element: react_1.default.createElement(PagesError404_1.default, null),
    },
    {
        path: "/admin",
        element: (react_1.default.createElement(routerUtils_1.ProtectedRoutes, { userType: [user_type_1.UserType.admin, user_type_1.UserType.superAdmin, user_type_1.UserType.collaborator, user_type_1.UserType.management] },
            react_1.default.createElement(AdminLayout_1.default, null))),
        children: [
            {
                element: react_1.default.createElement(react_router_dom_1.Navigate, { to: "/admin/tableau-de-bord", replace: true }),
                index: true,
            },
            {
                path: 'waze-sur-autoroute',
                element: react_1.default.createElement(AdminCheckWaze_1.AdminCheckWaze, null)
            },
            {
                path: 'google-maps-sur-autoroute',
                element: react_1.default.createElement(AdminCheckGoogleMaps_1.AdminCheckGoogleMaps, null)
            },
            {
                path: 'socket-io-metrics',
                element: react_1.default.createElement(DashboardSocketIo_1.default, null)
            },
            {
                path: 'api-orm-metrics',
                element: react_1.default.createElement(ORMMetrics_1.default, null)
            },
            {
                path: "tableau-de-bord",
                element: react_1.default.createElement(DashboardAdmin_1.default, null),
            },
            {
                path: "statistiques-et-reporting",
                element: react_1.default.createElement(StatistiquesReportingAdmin_1.default, null),
            },
            {
                path: "notifications",
                element: react_1.default.createElement(NotificationAdmin_1.default, null),
                children: [
                    {
                        element: (react_1.default.createElement(react_router_dom_1.Navigate, { to: "/admin/notifications/publiees", replace: true })),
                        index: true,
                    },
                    {
                        path: "publiees",
                        element: react_1.default.createElement(NotificationsPubliees_1.default, null),
                    },
                    {
                        path: "programmees",
                        element: react_1.default.createElement(NotificationsProgrammees_1.default, null),
                    },
                ],
            },
            {
                path: "mes-notifications",
                element: react_1.default.createElement(MyNotifications_1.default, null),
                children: [
                    {
                        element: (react_1.default.createElement(react_router_dom_1.Navigate, { to: "/admin/mes-notifications/recues", replace: true })),
                        index: true,
                    },
                    {
                        path: "recues",
                        element: react_1.default.createElement(MyNotificationsContent_1.default, null),
                    },
                ],
            },
            {
                path: "transactions",
                element: react_1.default.createElement(TransactionAdmin_1.default, null),
            },
            {
                path: "utilisateurs",
                element: react_1.default.createElement(UtilisateursAdmin_1.default, null),
            },
            {
                path: "utilisateurs/:slug",
                element: react_1.default.createElement(DetailsUtilisateurAdmin_1.default, null),
            },
            {
                path: "utilisateurs",
                element: react_1.default.createElement(UtilisateursAdmin_1.default, null),
            },
            {
                path: "suggestions",
                element: react_1.default.createElement(SuggestionAdmin_1.default, null),
            },
            {
                path: "signalements",
                element: react_1.default.createElement(SignalementAdmin_1.default, null),
            },
            {
                path: "sos-remorquage",
                element: react_1.default.createElement(SosRemorquagesAdmin_1.default, null),
            },
            {
                path: "sos-remorquage/:slug",
                element: react_1.default.createElement(SosRemorquagesDetails_1.default, null),
            },
            {
                path: "parametres",
                element: react_1.default.createElement(ParametresAdmin_1.default, null),
                children: [
                    {
                        element: (react_1.default.createElement(react_router_dom_1.Navigate, { to: "/admin/parametres/tarifs", replace: true })),
                        index: true,
                    },
                    {
                        path: "tarifs",
                        element: react_1.default.createElement(ParametresTarifs_1.default, null),
                    },
                    {
                        path: "espaces",
                        element: react_1.default.createElement(ParametresEspaces_1.default, null),
                    },
                    {
                        path: "administrateurs",
                        element: react_1.default.createElement(ParametresAdmins_1.default, null),
                    },
                    {
                        path: "politiques",
                        element: react_1.default.createElement(ParametresPolitiques_1.default, null),
                    },
                    {
                        path: "directions",
                        element: react_1.default.createElement(ParametresDirection_1.default, null),
                    },
                    {
                        path: "options",
                        element: react_1.default.createElement(ParametresOptions_1.default, null)
                    },
                    {
                        path: "faqs",
                        element: react_1.default.createElement(ParametresFaqs_1.default, null),
                    },
                ],
            },
            {
                path: "mon-compte",
                element: react_1.default.createElement(MonCompteAdmin_1.default, null),
            },
            {
                path: "rapidos",
                element: react_1.default.createElement(RapidosAdmin_1.default, null),
            },
        ],
    },
];
